import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { GetSearchParamsDto } from '@app/data/dtos/search/get-search-params.dto';
import { SearchHistoryRequestDto } from '@app/data/dtos/search/search-history-request.dto';
import { SearchHistoryDto } from '@app/data/dtos/search/search-history.dto';
import { SearchModelCollectionDto } from '@app/data/dtos/search/search-model-collection.dto';
import { SearchPublicationCollectionDto } from '@app/data/dtos/search/search-publication-collection.dto';
import { SearchSectionCollectionDto } from '@app/data/dtos/search/search-section-collection.dto';
import { SearchDto } from '@app/data/dtos/search/search.dto';

export interface SearchRepository {
  getSearch(searchParams: GetSearchParamsDto): Observable<SearchDto>;

  getSearchHistory(): Observable<SearchHistoryDto>;

  setSearchHistory(body: SearchHistoryRequestDto): Observable<null>;

  getSearchModel(searchParams: GetSearchParamsDto): Observable<SearchModelCollectionDto>;

  getSearchPublications(searchParams: GetSearchParamsDto): Observable<SearchPublicationCollectionDto>;

  getSearchSection(searchParams: GetSearchParamsDto): Observable<SearchSectionCollectionDto>;
}

export const SEARCH_REPOSITORY = new InjectionToken<SearchRepository>('SEARCH_REPOSITORY');
